import { render } from "./Auth.vue?vue&type=template&id=3a999904&scoped=true"
import script from "./Auth.vue?vue&type=script&setup=true&lang=js"
export * from "./Auth.vue?vue&type=script&setup=true&lang=js"

import "./Auth.vue?vue&type=style&index=0&id=3a999904&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a999904"],['__file',"resources/js/base/layouts/Auth.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a999904"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a999904', __exports__)) {
    api.reload('3a999904', __exports__)
  }
  
  module.hot.accept("./Auth.vue?vue&type=template&id=3a999904&scoped=true", () => {
    api.rerender('3a999904', render)
  })

}


export default __exports__